<template>
  <div>
    <v-snackbar
      v-for="snackbar in snackbars"
      :key="snackbar.id"
      v-model="snackbar.show"
      :color="snackbar.color"
      :timeout="snackbar.timeout"
      :location="snackbar.location || 'bottom'"
      :multi-line="snackbar.multiLine"
      :vertical="snackbar.vertical"
      @update:model-value="(value) => onSnackbarUpdate(snackbar.id, value)"
    >
      {{ snackbar.message }}
      <template #actions>
        <v-btn 
          variant="text" 
          @click="closeSnackbar(snackbar.id)"
        >
          Close
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script setup>
import { useSnackbarManager } from '../../utils/SnackbarManager'

const { snackbars, closeSnackbar } = useSnackbarManager()

const onSnackbarUpdate = (id, value) => {
  if (!value) {
    closeSnackbar(id)
  }
}
</script>
